<template>
    <div>
        <Header v-bind:title="'就医记录'" v-bind:back="true"></Header>
        <van-tabs v-model="active" swipeable sticky color="#26a2ff">
            <van-tab title="处方信息">
                <van-cell-group>
                    <van-cell title="处方日期" :value="row.cfrq" />
                    <van-cell title="处方编号" :value="row.cfh" />
                    <van-cell title="科室名称" :value="row.jzks" />
                    <van-cell title="医生姓名" :value="row.ysxm" />
                    <van-cell title="处方类型" :value="row.cflx" />
                    <van-cell title="处方金额" :value="row.cfje+'元'" />
                </van-cell-group>
            </van-tab>
            <van-tab title="明细">
                <van-list
                        v-model="cfxx.loading"
                        :finished="cfxx.finished"
                        :finished-text="cfxx.list.length > 0 ? '已全部加载' : '无明细记录'"
                        @load="getCfmx()">
                    <van-cell-group v-for="(item,index) in cfxx.list" :key="item.cfh">
                        <van-cell center :title="item.ypmc" is-link @click="showInfo(item)">
                            <template slot="label">
                                <span><span style="color:#393939">药品规格：</span>{{item.ypgg}}</span><br>
                                <span><span style="color:#393939">服用剂量：</span>{{item.fyjl}}，<span style="color:#393939">服用方法：</span>{{item.fyff}}，<span style="color:#393939">天数：</span>{{item.ts}}</span><br>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
        </van-tabs>
        <show-info ref="ShowInfo" v-bind:title="infoTitle" v-bind:list="infoList"></show-info>
    </div>
</template>
<script type="text/ecmascript-6">
    import Header from './components/Header.vue'
    import ShowInfo from './components/ShowInfo.vue'
    import {findCfMx} from '@/api/biApi.js'
    let Base64 = require('js-base64').Base64
    export default{
        name:'',
        components:{Header,ShowInfo},
        data(){
            return {
                row:{},
                active:'',
                infoTitle:'',
                infoList:[],
                cfxx:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                },
                pageSize:200,
            }
        },
        mounted(){
            this.row = this.$route.params.row ? JSON.parse(Base64.decode(this.$route.params.row)) : {}
        },
        methods:{
            getCfmx(){
                this.cfxx.page += 1
                findCfMx({
                    "cfh":this.row.cfh,
                    "size":this.pageSize,
                    "page":this.cfxx.page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.cfxx.list.push(val)
                        })
                    }
                    this.cfxx.loading = false;
                    this.cfxx.finished = true;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.cfxx.loading = false;
                    this.cfxx.finished = true;
                })
            },
            showInfo(row){
                this.infoTitle = row.ypmc
                this.infoList  = [
                    {title:'序号',value:row.xh},
                    {title:'组号',value:row.zh},
                    {title:'药品名称',value:row.ypmc},
                    {title:'药品规格',value:row.ypgg},
                    {title:'服用剂量',value:row.fyjl},
                    {title:'剂量单位',value:row.jldw},
                    {title:'服用方法',value:row.fyff},
                    {title:'频次',value:row.pc},
                    {title:'服用天数',value:row.ts},
                    {title:'总量',value:row.zl},
                    {title:'药房单位',value:row.yfdw},
                ];
                this.$refs.ShowInfo.show = true
            },
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile/mzjl-cf-xx.vue